import { useQuery } from '@tanstack/react-query';

import { getMediaPackage } from '~/services/MediaService';

import { mediaPackageQueryKeys } from './mediaQueryKeys';

/** Fetches one media package with the assets it bundles. */
export function useGetMediaPackage(mediaPackageId: string) {
  return useQuery({
    queryKey: mediaPackageQueryKeys.detail(mediaPackageId),
    queryFn: ({ signal }) => getMediaPackage(mediaPackageId, { signal }),
    enabled: Boolean(mediaPackageId),
  });
}
